module.exports = __webpack_public_path__ + "static/media/mail.62a15598.svg";